// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExecutedMints2Step } from '@hooks/queries/registry/mint/useExecutedMints2Step';
import { useMintRequests2Step } from '@hooks/queries/registry/mint/useMintRequests2Step';
import { useRejectedMints2Step } from '@hooks/queries/registry/mint/useRejectedMints2Step';

export const useGetMintQueries = () => {
  const mintRequest = useMintRequests2Step();
  const executedMint = useExecutedMints2Step();
  const rejectedMints = useRejectedMints2Step();
  return {
    mintRequest,
    executedMint,
    rejectedMints,
  };
};
